export const initialState = {
  // Pages
  isDashboardClicked: true,
  isDeliveriesClicked: false,
  isDriversClicked: false,
  isAddressesClicked: false,
  isIntegrationsClicked: false,
  isVehiclesClicked: false,

  // Modals
  isModalsBgShown: false,
  isDeleteModalShown: false,
  isAddNewDriverShown: false,
  isDriverLocationShown: false,
  isDriverInfoShown: false,
  isDriverRoutes: false,
  isEditModalShown: false,
  isDeleteConfirmShown: false,
  isDeleteCustomerAddress: false,
  isAddNewCustomerAddress: false,
  isAddLaundry: false,
  isErrorMsg: false,
  isMapShown: false,
  isDownloadAppShown: false,
  showThreeDotsModal: false,
  modalPosition: { x: 0, y: 0 },
  isGenerateApiShown: false,
  isApiKeyModalShown: false,
  isOrderInformationOpen: false,
  isDeleteVehicleShown: false,

  // Data
  selectedDriverId: null,
  selectedDelivery: null,
  errorMsg: "",
  successMsg: "",
  addressData: [],
  selectedDataForEdit: null,
  selectedDriverInfo: null,
  selectedAddress: null,
  language: "en",
  selectedOrderIndex: 0,
  deliveriesToDisplay: [],
  selectedPackage: null,
  isDriverLocationFromRoutes: false,
  selectedDriverLocationIndex: 0,
  shouldResetData: true,

  // UI and State Flags
  isActiveSidebarBtn: "dashboard",
  isEditMode: false,
  isWithHistory: false,
  isCustomerActive: true,
  isFetchCurrentAddress: false,
  isNewPickupAddressCreated: false,
  isNewCustomerCreated: false,
  shouldResetScheduledPackage: false,
};
